import { BaseModal, ConfirmationModal } from '@/lib/Modals';
import { ModalDescription, ModalTitle } from '@/lib/Modals/common';
import { ConfirmationModalFooter } from '@/lib/Modals/ConfirmationModal/ConfirmationModalFooter';
import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

type ConnectorInReviewModalProps = Omit<ComponentProps<typeof BaseModal>, 'children'> & Omit<ComponentProps<typeof ConfirmationModalFooter>, 'onCancel'>;

export const ConnectorInReviewModal: FC<ConnectorInReviewModalProps> = ({ onConfirm, onClose, ...props }) => {
  const { t } = useTranslation(['ALL', 'COMMON']);

  return (
    <ConfirmationModal onClose={onClose} onConfirm={onConfirm} confirmText='support:writeToSupport' {...props}>
      <div className='text-center'>
        <ModalTitle>{t('COMMON:inReview')}</ModalTitle>
        <ModalDescription>{t('ALL:destinations.connectorInReview')}</ModalDescription>
      </div>
    </ConfirmationModal>
  );
};
